import * as React from 'react';
import styled from 'styled-components';

export type Animate = (showed: boolean) => React.CSSProperties;

export const Animation = styled.div`
    transition: all .33s ease-in-out;
`;

const enter: React.CSSProperties = { opacity: 1, pointerEvents: 'auto' };
const leave: React.CSSProperties = { opacity: 0, pointerEvents: 'none' };


export const fadeTop: Animate = (s) => s 
    ? { ...enter, transform: 'translateY(0)' }
    : { ...leave, transform: 'translateY(-5px)' };

export const fadeBottom: Animate = (s) => s
    ? { ...enter, transform: 'translateY(0)' }
    : { ...leave, transform: 'translateY(5px)' };

export const fadeLeft: Animate = (s) => s
    ? { ...enter, transform: 'translateX(0)' }
    : { ...leave, transform: 'translateX(-5px)' };

export const fadeRight: Animate = (s) => s
    ? { ...enter, transform: 'translateX(0)' }
    : { ...leave, transform: 'translateX(5px)' };
